import { useAtomValue } from 'jotai';
import { FC } from 'react';

import { AgTable } from '../../../components/AgTable/AgTable';
import { FadeInGridWrapper } from '../../../components/grid-renderers/FadeInGridWrapper';
import { Loader } from '../../../components/Loader/Loader';
import { selectedCompanyIdStateFinanceJ } from '../../../services/state/PortCosStateJ';
import { ErrorOccurredMessage } from '../../CompanyProfiles/components/Messages/HelpMessage';
import { defaultColDef } from '../common-grid-defs/defaultColDefs';
import { roundsByCompanyIdStateLoadableJ } from '../state/FinanceStateJ';
import { useRoundTableColDefs } from './useRoundTableColDefs';

export const RoundTable: FC = () => {
  const selectedCompanyId = useAtomValue(selectedCompanyIdStateFinanceJ);
  const roundsByCompanyLoadable = useAtomValue(roundsByCompanyIdStateLoadableJ(selectedCompanyId ?? -1));
  const roundsByCompany = roundsByCompanyLoadable.state === 'hasData' ? roundsByCompanyLoadable.data : null;
  const columnDefs = useRoundTableColDefs();

  if (roundsByCompanyLoadable.state === 'loading') {
    return <Loader height='80%' />;
  }
  if (roundsByCompanyLoadable.state === 'hasError') {
    return <ErrorOccurredMessage />;
  }

  return (
    <FadeInGridWrapper key={selectedCompanyId}>
      <div style={{ height: '70vh', paddingTop: '2rem' }}>
        <AgTable
          key={selectedCompanyId}
          columnDefs={columnDefs}
          rowData={roundsByCompany ?? []}
          defaultColDef={{ ...defaultColDef, minWidth: 150 }}
          grandTotalRow='bottom'
        />
      </div>
    </FadeInGridWrapper>
  );
};
